<template>
  <div>
    <!-- 搜索筛选 -->
    <div class="query-select">
      <el-form :inline="true" :model="queryForm" class="user-search">
        <el-form-item label="名称：">
          <el-input
            size="small"
            v-model="queryForm.name"
            placeholder="输入名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="创建日期：" class="mr-left">
          <el-date-picker
            @change="dateRangeChange"
            v-model="dateRange"
            size="small"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="div_select_button">
        <el-button
          type="primary"
          icon="el-icon-search"
          plain
          size="small"
          round
          @click="getTableList"
          >查询</el-button
        >
        <el-button
          type="warning"
          icon="el-icon-refresh-left"
          plain
          size="small"
          round
          @click="resetSelect"
          >重置</el-button
        >
        <el-button
          type="success"
          icon="el-icon-plus"
          plain
          size="small"
          round
          @click="addForm"
          >新增</el-button
        >
      </div>
    </div>
    <!--列表-->
    <div class="main-table">
      <el-table
        header-cell-class-name="table-header"
        border
        stripe
        size="small"
        :data="listData"
        highlight-current-row
        v-loading="loading"
        element-loading-text="拼命加载中"
        style="width: 85vw"
      >
        <el-table-column align="center" type="index" width="60">
        </el-table-column>
        <el-table-column
          align="center"
          prop="examinationCode"
          label="考试编码"
          width="140"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="name"
          label="考试名称"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="minTime"
          label="考试开始时间"
          width="240"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="maxTime"
          label="考试结束时间"
          width="240"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="createTime"
          label="创建日期"
          width="200"
          show-overflow-tooltip
        >
        </el-table-column>

        <el-table-column align="center" label="操作" width="440">
          <template slot-scope="scope">
            <el-button
              plain
              size="mini"
              round
              type="primary"
              @click="handleEdit(scope.$index, scope.row, 1)"
              >查看</el-button
            >
            <!-- <el-button
              plain
              size="mini"
              round
              type="warning"
              v-if="new Date() < new Date(scope.row.minTime)"
              @click="handleEdit(scope.$index, scope.row, 0)"
              >编辑</el-button
            > -->
            <el-button
              type="danger"
              plain
              size="mini"
              round
              v-if="new Date() < new Date(scope.row.minTime)"
              @click="deleteUser(scope.$index, scope.row)"
              >删除</el-button
            >
            <el-button
              type="primary"
              plain
              size="mini"
              round
              v-if="new Date() < new Date(scope.row.minTime)"
              @click="handlePaper(scope.row)"
              >生成试卷</el-button
            >
            <el-button
              type="success"
              plain
              size="mini"
              round
              v-if="new Date() > new Date(scope.row.maxTime)"
              @click="handleGrade(scope.row)"
              >成绩生成</el-button
            >

            <el-button
              type="success"
              plain
              size="mini"
              round
              v-if="new Date() > new Date(scope.row.maxTime)"
              @click="openScore(scope.row)"
              >简答评分</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <el-pagination
        @current-change="getTableList"
        :current-page.sync="queryForm.pageNum"
        :page-size="10"
        layout="total, prev, pager, next"
        :total="totals"
      >
      </el-pagination>
    </div>
    <TestDialog ref="TestDialogRef" @success="getTableList" />
    <ScoreDialog ref="scoreDialogRef" @success="getTableList" />
  </div>
</template>

<script>
import Pagination from "../../components/Pagination";
import ScoreDialog from "./ScoreDialog.vue";
import { getMinTime, getMaxTime, tansParams } from "@/utils/util";
import TestDialog from "./TestDialog";
import { editStatusExamination } from "../../api/addAndUpadte";

import {
  getList,
  deleteInfo,
  generateStartExamPaper,
  practicalScoreHandel,
  theoryScoreHandel
} from "@/api/exam";
export default {
  data() {
    return {
      IsdateRange: false,
      dateRange: null,
      totals: 0,
      loading: false, //是显示加载
      queryForm: {
        name: "",
        dateRange: null,
        pageNum: 1,
        pageSize: 10
      },
      listData: [] //用户数据
    };
  },
  // 注册组件
  components: {
    Pagination,
    ScoreDialog,
    TestDialog
  },
  created() {
    this.getTableList();
  },
  mounted() {},
  methods: {
    getMinTime,
    getMaxTime,
    dateRangeChange(val) {
      this.queryForm.params = { beginTime: val[0], endTime: val[1] };
      this.getTableList();
    },
    openScore(row) {
      this.$refs.scoreDialogRef.open(row);
    },
    async stopTest(row) {
      let res = await editStatusExamination({
        examinationId: row.examinationId, //考试编码
        status: "3" //状态 3 为停止考试
      });
      let result = res.data;
      if (result.code == 200) {
        this.getTableList();
      } else {
        this.$message({
          type: "error",
          message: result.msg
        });
      }
    },
    async handlePaper(row) {
      const loading = this.$loading({
        lock: true,
        text: "生成试卷中,请勿刷新页面...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        await generateStartExamPaper({ examinationId: row.examinationId });
        this.$message({
          type: "success",
          message: "操作成功"
        });
      } finally {
        loading.close();
      }
    },
    resetSelect() {
      this.queryForm = {
        name: "",
        dateRange: null,
        pageNum: 1,
        pageSize: 10
      };
      this.dateRange = [];
      this.getTableList();
    },
    //显示编辑界面
    handleEdit(index, row, val) {
      if (val == 1) {
        this.$refs.TestDialogRef.open("view", row);
      } else if (val == 0) {
        this.$refs.TestDialogRef.open("edit", row);
      }
    },
    addForm() {
      this.$refs.TestDialogRef.open("add");
    },
    async getTableList() {
      // if (this.dateRange && this.dateRange.length > 0) {
      //   this.queryForm.beginTime = this.dateRange[0] + " 00:00:00";
      //   this.queryForm.endTime = this.dateRange[1] + " 23:59:59";
      // }
      const res = await getList(tansParams(this.queryForm));
      let result = res.data;
      if (result.code === 200) {
        this.loading = false;

        this.listData = result.data.rows.map(item => ({
          ...item,
          minTime: this.getMinTime(item.startTime, item.practicalExamStartTime),
          maxTime: this.getMaxTime(item.endTime, item.practicalExamEndTime)
        }));
        console.log(this.listData);
        this.totals = result.data.total;
      } else {
        this.loading = false;
      }
    },
    async handleGrade(row) {
      const loading = this.$loading();
      try {
        const formData = new FormData();
        formData.append("examinationCode", row.examinationCode);
        await theoryScoreHandel(formData);
        this.$message({
          type: "success",
          message: "理论成绩生成成功"
        });
        await practicalScoreHandel(formData);
        this.$message({
          type: "success",
          message: "实操成绩生成成功"
        });
      } finally {
        loading.close();
      }
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.deleteDetail(row.examinationId);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    async deleteDetail(val) {
      const res = await deleteInfo(val);
      let result = res.data;
      if (result.data.code === 200) {
        this.loading = false;
        this.getTableList();
      } else {
        this.loading = false;
        this.$message.error(result.data.msg);
      }
    }
  }
};
</script>

<style scoped lang="less"></style>



// WEBPACK FOOTER //
// src/views/TestManage/TestManage.vue